import { apiInstance } from "./networking";
export const coAuthorisedUpload = async (payload) => {
    const {data = {}} = await apiInstance.post(`primary/corporate-subdocument-upload`,payload);
    return data;
};

